<!-- Custom Notification -->
<div class="custom-notification" [class.show]="notification.show" [class.success]="notification.type === 'success'" [class.error]="notification.type === 'error'">
  <div class="notification-content">
    <i class="fas fa-check-circle" *ngIf="notification.type === 'success'"></i>
    <i class="fas fa-exclamation-circle" *ngIf="notification.type === 'error'"></i>
    <span>{{ notification.message }}</span>
    <button class="close-btn" (click)="hideNotification()">
      <i class="fas fa-times"></i>
    </button>
  </div>
</div>

<!-- Header Section -->
<div class="case-management-header">
  <h2>Interactive Case & Order Management</h2>
  <p>Manage interactive cases and orders for the CCS system</p>
</div>

<div class="">
  <div class="content-wrapper">
    <!-- Tab Navigation -->
    <ul class="nav nav-tabs" id="managementTab" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="nav-link" 
                [class.active]="activeTab === 'cases'"
                (click)="switchTab('cases')"
                type="button" role="tab">
          <i class="fas fa-file-medical"></i> Manage Cases
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" 
                [class.active]="activeTab === 'orders'"
                (click)="switchTab('orders')"
                type="button" role="tab">
          <i class="fas fa-clipboard-list"></i> Manage Orders
        </button>
      </li>
    </ul>

    <!-- Tab Content -->
    <div class="tab-content" id="managementTabContent">
      
      <!-- Cases Management Tab -->
      <div class="tab-pane fade" [class.show]="activeTab === 'cases'" [class.active]="activeTab === 'cases'">
        <div class="section-container">
          <div class="section-header">
            <div class="header-left">
              <h5 class="mb-0">Interactive Cases</h5>
              <span class="count-badge">{{ cases.length }} cases</span>
            </div>
            <div class="header-right">
              <button class="btn btn-primary btn-sm" (click)="openCaseModal('add')">
                <i class="fas fa-plus"></i> Add Interactive Case
              </button>
            </div>
          </div>

          <!-- Search Bar -->
          <div class="search-container">
            <div class="search-box">
              <i class="fas fa-search"></i>
              <input type="text" 
                     class="form-control" 
                     placeholder="Search cases..." 
                     [(ngModel)]="searchTerm"
                     (input)="filterCases()">
            </div>
          </div>

          <!-- Loading Spinner -->
        

          <!-- Cases Table -->
          <div *ngIf="!loading" class="table-responsive">
            <table class="table table-hover">
              <thead class="table-dark">
                <tr>
                  <th>#</th>
                  <th>Case No</th>
                  <th>Specialty</th>
                  <th>Sub-Specialty</th>
                  <th>Location</th>
                  <th>Duration</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let case of filteredCases; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ case.case_id }}</td>
                  <td>{{ case.specialty }}</td>
                  <td>{{ case.subSpecialty }}</td>
                  <td>{{ case.location }}</td>
                  <td>{{ case.duration }} minutes</td>
                  <td class="actions-cell">
                    <button class="btn-icon edit" (click)="openCaseModal('edit', case)" title="Edit">
                      <i class="fas fa-edit"></i>
                    </button>
                    <button class="btn-icon explanation" (click)="openExplanationModal(case)" title="Manage Explanation">
                      <i class="fas fa-book-open"></i>
                    </button>
                    <button class="btn-icon delete" (click)="deleteCase(case)" title="Delete">
                      <i class="fas fa-trash"></i>
                    </button>
                  </td>
                </tr>
                <tr *ngIf="filteredCases.length === 0">
                  <td colspan="7" class="text-center py-4">
                    <span *ngIf="searchTerm">No cases found matching "{{ searchTerm }}"</span>
                    <span *ngIf="!searchTerm">No cases found</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Orders Management Tab -->
      <div class="tab-pane fade" [class.show]="activeTab === 'orders'" [class.active]="activeTab === 'orders'">
        <div class="orders-management">
          <div class="section-container">
            <div class="orders-header">
              <h3>Order Management</h3>
              <div class="order-tabs">
                <button 
                  class="tab-btn" 
                  [class.active]="orderActiveTab === 'orders'"
                  (click)="switchOrderTab('orders')">
                  <i class="fas fa-list-ul"></i> Orders
                </button>
                <button 
                  class="tab-btn" 
                  [class.active]="orderActiveTab === 'categories'"
                  (click)="switchOrderTab('categories')">
                  <i class="fas fa-tags"></i> Categories
                </button>
                <button 
                  class="tab-btn" 
                  [class.active]="orderActiveTab === 'types'"
                  (click)="switchOrderTab('types')">
                  <i class="fas fa-layer-group"></i> Types
                </button>
              </div>
            </div>

            <!-- Orders Sub-tab -->
            <div *ngIf="orderActiveTab === 'orders'" class="orders-section">
              <div class="section-header">
                <div class="header-left">
                  <h4 class="mb-0">Orders</h4>
                  <span class="count-badge">{{ orders.length }} orders</span>
                </div>
                <div class="header-right">
                  <div class="search-container">
                    <div class="search-box">
                      <i class="fas fa-search"></i>
                      <input 
                        type="text" 
                        class="form-control"
                        placeholder="Search orders..." 
                        [(ngModel)]="orderSearchTerm"
                        (input)="filterOrders()">
                    </div>
                  </div>
                  <button class="btn btn-primary btn-sm" (click)="openOrderModal('add')">
                    <i class="fas fa-plus"></i> Add Order
                  </button>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table table-hover">
                  <thead class="table-dark">
                    <tr>
                      <th>Order Name</th>
                      <th>Category</th>
                      <th>Type</th>
                      <th>Frequency</th>
                      <th>Day</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let order of filteredOrders">
                      <td>{{ order.orderName }}</td>
                      <td>{{ order.categoryName }}</td>
                      <td>{{ order.typeName }}</td>
                      <td>{{ order.frequencyVal || '-' }}</td>
                      <td>{{ order.orderDay || '-' }}</td>
                      <td class="actions-cell">
                        <button class="btn-icon edit" (click)="openOrderModal('edit', order)" title="Edit">
                          <i class="fas fa-edit"></i>
                        </button>
                        <button class="btn-icon delete" (click)="deleteOrder(order)" title="Delete">
                          <i class="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                    <tr *ngIf="filteredOrders.length === 0">
                      <td colspan="6" class="text-center py-4">
                        <span *ngIf="orderSearchTerm">No orders found matching "{{ orderSearchTerm }}"</span>
                        <span *ngIf="!orderSearchTerm">No orders found</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Categories Sub-tab -->
            <div *ngIf="orderActiveTab === 'categories'" class="categories-section">
              <div class="section-header">
                <div class="header-left">
                  <h4 class="mb-0">Order Categories</h4>
                  <span class="count-badge">{{ orderCategories.length }} categories</span>
                </div>
                <div class="header-right">
                  <button class="btn btn-primary btn-sm" (click)="openCategoryModal('add')">
                    <i class="fas fa-plus"></i> Add Category
                  </button>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table table-hover">
                  <thead class="table-dark">
                    <tr>
                      <th>Category Name</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let category of orderCategories">
                      <td>{{ category.name }}</td>
                      <td class="actions-cell">
                        <button class="btn-icon edit" (click)="openCategoryModal('edit', category)" title="Edit">
                          <i class="fas fa-edit"></i>
                        </button>
                        <button class="btn-icon delete" (click)="deleteCategory(category)" title="Delete">
                          <i class="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                    <tr *ngIf="orderCategories.length === 0">
                      <td colspan="2" class="text-center py-4">No categories found</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Types Sub-tab -->
            <div *ngIf="orderActiveTab === 'types'" class="types-section">
              <div class="section-header">
                <div class="header-left">
                  <h4 class="mb-0">Order Types</h4>
                  <span class="count-badge">{{ orderTypes.length }} types</span>
                </div>
                <div class="header-right">
                  <button class="btn btn-primary btn-sm" (click)="openTypeModal('add')">
                    <i class="fas fa-plus"></i> Add Type
                  </button>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table table-hover">
                  <thead class="table-dark">
                    <tr>
                      <th>Type Name</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let type of orderTypes">
                      <td>{{ type.type }}</td>
                      <td class="actions-cell">
                        <button class="btn-icon edit" (click)="openTypeModal('edit', type)" title="Edit">
                          <i class="fas fa-edit"></i>
                        </button>
                        <button class="btn-icon delete" (click)="deleteOrderType(type)" title="Delete">
                          <i class="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                    <tr *ngIf="orderTypes.length === 0">
                      <td colspan="2" class="text-center py-4">No types found</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Case Modal -->
<div class="modal fade" [class.show]="showCaseModal" [style.display]="showCaseModal ? 'block' : 'none'" 
     tabindex="-1" role="dialog" *ngIf="showCaseModal">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fas fa-file-medical"></i>
          {{ modalType === 'add' ? 'Add New Interactive Case' : 'Edit Interactive Case' }}
        </h5>
        <button type="button" class="btn-close" (click)="closeCaseModal()"></button>
      </div>
      
      <div class="modal-body">
        <form [formGroup]="caseForm" (ngSubmit)="saveCase()">
          
          <!-- Initial Case Details Section -->
          <div class="form-section">
            <h6 class="section-title">
              <i class="fas fa-info-circle"></i> Initial Case Details
            </h6>
            
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="specialty" class="form-label">Specialty *</label>
                  <input type="text" 
                         id="specialty"
                         class="form-control" 
                         formControlName="specialty"
                         placeholder="Enter specialty">
                </div>
              </div>
              
              <div class="col-md-6">
                <div class="form-group">
                  <label for="subSpecialty" class="form-label">Sub-Specialty *</label>
                  <input type="text" 
                         id="subSpecialty"
                         class="form-control" 
                         formControlName="subSpecialty"
                         placeholder="Enter sub-specialty">
                </div>
              </div>
            </div>
            
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="location" class="form-label">Location *</label>
                  <select id="location" class="form-control" formControlName="location">
                    <option value="">Select location</option>
                    <option *ngFor="let location of locationOptions" [value]="location.value">
                      {{ location.label }}
                    </option>
                  </select>
                </div>
              </div>
              
              <div class="col-md-6">
                <div class="form-group">
                  <label for="duration" class="form-label">Duration (minutes) *</label>
                  <input type="number" 
                         id="duration"
                         class="form-control" 
                         formControlName="duration"
                         placeholder="Enter duration in minutes"
                         min="1">
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12">
                <div class="form-group">
                  <label for="preOrders" class="form-label">Pre-Existing Orders</label>
                  <p-multiSelect 
                    [options]="orders" 
                    formControlName="preOrders"
                    optionLabel="orderName" 
                    optionValue="id"
                    placeholder="Select pre-existing orders..."
                    [filter]="true"
                    filterBy="orderName"
                    [showToggleAll]="false"
                    [showHeader]="true"
                    [showClear]="true"
                    styleClass="w-100">
                  </p-multiSelect>
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="maxSimulatedTime" class="form-label">Maximum Simulated Time (days) *</label>
                  <input type="number" 
                         id="maxSimulatedTime"
                         class="form-control" 
                         formControlName="maxSimulatedTime"
                         placeholder="Enter maximum simulated time in minutes"
                         min="0">
                  <small class="form-text text-muted">Maximum time allowed for case simulation</small>
                </div>
              </div>
            </div>
          </div>

          <!-- Case Details Section -->
          <div class="form-section">
            <h6 class="section-title">
              <i class="fas fa-file-alt"></i> Case Details
            </h6>
            
            <div class="form-group">
              <label for="introduction" class="form-label">Introduction of the Case</label>
              <div id="ck-editor-introduction" class="ck-editor-container"></div>
            </div>
            
            <div class="form-group">
              <label for="initialHistory" class="form-label">Initial History</label>
              <div id="ck-editor-history" class="ck-editor-container"></div>
            </div>
            
            <!-- Baseline Vitals -->
            <div class="form-group">
              <label class="form-label">Baseline Vitals</label>
              <div class="vitals-grid" formGroupName="baselineVitals">
                <div class="row">
                  <div class="col-md-4">
                    <label for="temperature" class="form-label">Temperature (°C)</label>
                    <input type="number" 
                           id="temperature"
                           class="form-control" 
                           formControlName="temperature"
                           step="0.1">
                  </div>
                  <div class="col-md-4">
                   
                    <label for="pulse" class="form-label">Pulse (beats/min)</label>
                    <input type="number" 
                           id="pulse"
                           class="form-control" 
                           formControlName="pulse">

                           <label class="form-label">Pulse Quality</label>
                           <div class="radio-group mb-2">
                             <div class="form-check form-check-inline">
                               <input class="form-check-input" 
                                      type="radio" 
                                      id="pulseRegular"
                                      formControlName="pulseQuality" 
                                      value="Regular">
                               <label class="form-check-label" for="pulseRegular">
                                 Regular
                               </label>
                             </div>
                             <div class="form-check form-check-inline">
                               <input class="form-check-input" 
                                      type="radio" 
                                      id="pulseIrregular"
                                      formControlName="pulseQuality" 
                                      value="Irregular">
                               <label class="form-check-label" for="pulseIrregular">
                                 Irregular
                               </label>
                             </div>
                           </div>
                  </div>
                  <div class="col-md-4">
                    <label for="respiratoryRate" class="form-label">Respiratory Rate (/min)</label>
                    <input type="number" 
                           id="respiratoryRate"
                           class="form-control" 
                           formControlName="respiratoryRate">
                  </div>
                </div>
                
                <div class="row">
                  <div class="col-md-4">
                    <label for="systolicBP" class="form-label">Systolic BP (mmHg)</label>
                    <input type="number" 
                           id="systolicBP"
                           class="form-control" 
                           formControlName="systolicBP">
                  </div>
                  <div class="col-md-4">
                    <label for="diastolicBP" class="form-label">Diastolic BP (mmHg)</label>
                    <input type="number" 
                           id="diastolicBP"
                           class="form-control" 
                           formControlName="diastolicBP">
                  </div>
                  <div class="col-md-4">
                    <label for="height" class="form-label">Height (cm)</label>
                    <input type="number" 
                           id="height"
                           class="form-control" 
                           formControlName="height"
                           (input)="calculateBMI()">
                  </div>
                </div>
                
                <div class="row">
                  <div class="col-md-4">
                    <label for="weight" class="form-label">Weight (kg)</label>
                    <input type="number" 
                           id="weight"
                           class="form-control" 
                           formControlName="weight"
                           step="1"
                           (input)="calculateBMI()">
                  </div>
                  <div class="col-md-4">
                    <label for="bmi" class="form-label">BMI (kg/m²)</label>
                    <input type="number" 
                           id="bmi"
                           class="form-control" 
                           formControlName="bmi"
                           step="1"
                           >
                  </div>
                </div>
              </div>
            </div>
            
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="caseDay" class="form-label">Case Day *</label>
                  <input type="number" 
                         id="caseDay"
                         class="form-control" 
                         formControlName="caseDay"
                         min="1">
                </div>
              </div>
              
              <div class="col-md-6">
                <div class="form-group">
                  <label for="caseTime" class="form-label">Case Time *</label>
                  <input type="text" 
                         id="caseTime"
                         class="form-control" 
                         formControlName="caseTime"
                         placeholder="e.g., 1400 for 2:00 PM"
                         pattern="[0-9]{4}">
                  <small class="form-text text-muted">Use 24-hour format: 1400 for 2:00 PM, 0800 for 8:00 AM</small>
                </div>
              </div>
            </div>
          </div>

          <!-- Case Conditions Section -->
          <div class="form-section">
            <h6 class="section-title">
              <i class="fas fa-list"></i> Case Conditions
              <button type="button" class="btn btn-sm btn-outline-primary ms-2" (click)="addCondition()">
                <i class="fas fa-plus"></i> Add Condition
              </button>
            </h6>
            
            <div formArrayName="conditions">
              <div *ngFor="let condition of conditionsArray.controls; let i = index" 
                   [formGroupName]="i" 
                   class="condition-item">
                <div class="condition-header">
                  <h6>Condition {{ i + 1 }}</h6>
                  <button type="button" 
                          class="btn btn-sm btn-outline-danger" 
                          (click)="removeCondition(i)"
                          *ngIf="conditionsArray.length > 0">
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
                
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="form-label">Day of Condition *</label>
                      <input type="number" 
                             class="form-control" 
                             formControlName="day"
                             min="1">
                    </div>
                  </div>
                  
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="form-label">Time of Condition *</label>
                      <input type="text" 
                             class="form-control" 
                             formControlName="time"
                             placeholder="e.g., 1400"
                             pattern="[0-9]{4}">
                    </div>
                  </div>
                  
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="form-label">Linked Orders</label>
                      <p-multiSelect 
                        [options]="orders" 
                        formControlName="linkedOrders"
                        optionLabel="orderName" 
                        optionValue="id"
                        placeholder="Search and select orders..."
                        [filter]="true"
                        filterBy="orderName"
                        [showToggleAll]="false"
                        [showHeader]="false"
                        styleClass="w-100">
                      </p-multiSelect>
                    </div>
                  </div>
                </div>
                
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="form-label">Condition Type *</label>
                      <div class="radio-group">
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" 
                                 type="radio" 
                                 [id]="'positive_' + i"
                                 formControlName="conditionType" 
                                 [value]="1">
                          <label class="form-check-label" [for]="'positive_' + i">
                            <i class="fas fa-plus-circle text-success"></i> Positive
                          </label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" 
                                 type="radio" 
                                 [id]="'negative_' + i"
                                 formControlName="conditionType" 
                                 [value]="0">
                          <label class="form-check-label" [for]="'negative_' + i">
                            <i class="fas fa-minus-circle text-danger"></i> Negative
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div class="form-group">
                  <label class="form-label">Condition Description *</label>
                  <textarea class="form-control cond-text" 
                            formControlName="description"
                            rows="3"
                            placeholder="Describe the condition..."></textarea>
                </div>
              </div>
              
              <div *ngIf="conditionsArray.length === 0" class="text-center py-3 text-muted">
                No conditions added yet. Click "Add Condition" to add one.
              </div>
            </div>
          </div>

          <!-- Interval/Follow-up Section -->
          <div class="form-section">
            <h6 class="section-title">
              <i class="fas fa-clock"></i> Interval/Follow-up
              <button type="button" class="btn btn-sm btn-outline-primary ms-2" (click)="addInterval()">
                <i class="fas fa-plus"></i> Add Interval
              </button>
            </h6>
            
            <div formArrayName="intervals">
              <div *ngFor="let interval of intervalsArray.controls; let i = index" 
                   [formGroupName]="i" 
                   class="condition-item">
                <div class="condition-header">
                  <h6>Interval {{ i + 1 }}</h6>
                  <button type="button" 
                          class="btn btn-sm btn-outline-danger" 
                          (click)="removeInterval(i)"
                          *ngIf="intervalsArray.length > 0">
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
                
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="form-label">Day of Interval *</label>
                      <input type="number" 
                             class="form-control" 
                             formControlName="day"
                             min="1">
                    </div>
                  </div>
                  
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="form-label">Time of Interval *</label>
                      <input type="text" 
                             class="form-control" 
                             formControlName="time"
                             placeholder="e.g., 1400"
                             pattern="[0-9]{4}">
                    </div>
                  </div>
                </div>
                
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="form-label">Interval Type *</label>
                      <div class="radio-group">
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" 
                                 type="radio" 
                                 [id]="'interval_positive_' + i"
                                 formControlName="conditionType" 
                                 [value]="1">
                          <label class="form-check-label" [for]="'interval_positive_' + i">
                            <i class="fas fa-plus-circle text-success"></i> Positive
                          </label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" 
                                 type="radio" 
                                 [id]="'interval_negative_' + i"
                                 formControlName="conditionType" 
                                 [value]="0">
                          <label class="form-check-label" [for]="'interval_negative_' + i">
                            <i class="fas fa-minus-circle text-danger"></i> Negative
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div class="form-group">
                  <label class="form-label">Interval Description *</label>
                  <textarea class="form-control cond-text" 
                            formControlName="description"
                            rows="3"
                            placeholder="Describe the interval/follow-up..."></textarea>
                </div>
              </div>
              
              <div *ngIf="intervalsArray.length === 0" class="text-center py-3 text-muted">
                No intervals added yet. Click "Add Interval" to add one.
              </div>
            </div>
          </div>

          <!-- Physical Evaluation Section -->
          <div class="form-section">
            <h6 class="section-title">
              <i class="fas fa-stethoscope"></i> Physical Evaluation
            </h6>
            
            <div formGroupName="physicalEvaluations" *ngIf="physicalEvaluations.length > 0">
              <div class="physical-evaluations-grid">
                <div *ngFor="let evaluation of physicalEvaluations; let i = index" 
                     class="evaluation-item">
                  <div class="evaluation-header">
                    <h6 class="evaluation-title">
                      <i class="fas fa-user-md"></i>
                      {{ evaluation.type }}
                      <span class="duration-badge">{{ evaluation.duration }} min</span>
                    </h6>
                  </div>
                  
                  <div class="form-group">
                    <label [for]="'evaluation_' + evaluation.id" class="form-label">
                      Description for {{ evaluation.type }}
                    </label>
                    <textarea 
                      [id]="'evaluation_' + evaluation.id"
                      class="form-control evaluation-textarea" 
                      [formControlName]="'evaluation_' + evaluation.id"
                      rows="4"
                      [placeholder]="'Enter physical evaluation findings for ' + evaluation.type + '...'">
                    </textarea>
                  </div>
                </div>
              </div>
            </div>
            
            <div *ngIf="physicalEvaluations.length === 0" class="text-center py-3 text-muted">
              <i class="fas fa-spinner fa-spin"></i>
              Loading physical evaluation categories...
            </div>
          </div>

          <!-- Linked Orders Section -->
          <div class="form-section">
            <h6 class="section-title">
              <i class="fas fa-link"></i> Linked Orders
              <button type="button" class="btn btn-sm btn-outline-primary ms-2" (click)="addLinkedOrder()">
                <i class="fas fa-plus"></i> Add Order
              </button>
            </h6>
            
            <div formArrayName="linkedOrders">
              <div *ngFor="let linkedOrder of linkedOrdersArray.controls; let i = index" 
                   [formGroupName]="i" 
                   class="linked-order-item">
                <div class="linked-order-header">
                  <h6>Linked Order {{ i + 1 }}</h6>
                  <button type="button" 
                          class="btn btn-sm btn-outline-danger" 
                          (click)="removeLinkedOrder(i)"
                          *ngIf="linkedOrdersArray.length > 0">
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="form-label">Select Order *</label>
                      <p-dropdown 
                        [options]="orders" 
                        formControlName="id"
                        optionLabel="orderName" 
                        optionValue="id"
                        placeholder="Search and select an order..."
                        [filter]="true"
                        filterBy="orderName"
                        [showClear]="true"
                        styleClass="w-100"
                        appendTo="body"
                        (onChange)="onOrderSelectDropdown($event, i)">
                      </p-dropdown>
                    </div>
                  </div>
                  
                  
                </div>
                
                <div class="row" *ngIf="linkedOrder.get('id')?.value">
                  
                  
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="form-label">Custom Response *</label>
                      <div [id]="'linkedOrderResponseEditor_' + i" 
                           class="ck-editor-container linked-order-response-editor"
                           style="min-height: 120px; border: 1px solid #ddd; border-radius: 6px;">
                      </div>
                      <!-- Hidden input to maintain form validation -->
                      <input type="hidden" formControlName="customResponse">
                    </div>
                  </div>
                </div>
              </div>
              
              <div *ngIf="linkedOrdersArray.length === 0" class="text-center py-3 text-muted">
                No linked orders added yet. Click "Add Order" to link an order with this case.
              </div>
            </div>
          </div>

          <!-- Case Explanation Section -->
          <!-- <div class="form-section">
            <h6 class="section-title">
              <i class="fas fa-lightbulb"></i> Case Explanation
            </h6>
            
            <div class="form-group">
              <label for="explanation" class="form-label">Explanation</label>
              <div id="ck-editor-explanation" class="ck-editor-container"></div>
            </div>
          </div> -->
        </form>
      </div>
      
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeCaseModal()">
          <i class="fas fa-times"></i> Cancel
        </button>
        <button type="button" 
                class="btn btn-primary" 
                (click)="saveCase()"
                [disabled]="modalLoader || caseForm.invalid">
          <span *ngIf="modalLoader" class="spinner-border spinner-border-sm me-2"></span>
          <i class="fas fa-save" *ngIf="!modalLoader"></i>
          {{ modalType === 'add' ? 'Create Case' : 'Update Case' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Backdrop -->
<div class="modal-backdrop fade" [class.show]="showCaseModal" *ngIf="showCaseModal"></div>

<!-- Delete Confirmation Modal -->
<div class="modal-overlay delete-confirmation" *ngIf="showDeleteConfirmModal" (click)="closeDeleteModal()">
  <div class="modal-dialog delete-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h4>Confirm Delete</h4>
      <button class="close-btn" (click)="closeDeleteModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>
    
    <div class="modal-body">
      <!-- Error Message Display -->
      <div class="alert alert-danger" *ngIf="deleteErrorMessage" style="margin-bottom: 15px;">
        <i class="fas fa-exclamation-triangle" style="margin-right: 8px;"></i>
        {{ deleteErrorMessage }}
      </div>
      
      <p>Are you sure you want to delete this {{ deleteType }}?</p>
      
      <div class="case-details" *ngIf="itemToDelete">
        <div *ngIf="deleteType === 'case'">
          <strong>Case ID:</strong> {{ itemToDelete.id }}<br>
          <strong>Specialty:</strong> {{ itemToDelete.specialty }}<br>
          <strong>Sub-Specialty:</strong> {{ itemToDelete.subSpecialty }}<br>
          <strong>Location:</strong> {{ itemToDelete.location }}
        </div>
        <div *ngIf="deleteType === 'order'">
          <strong>Order Name:</strong> {{ itemToDelete.orderName }}<br>
          <strong>Category:</strong> {{ itemToDelete.categoryName }}<br>
          <strong>Type:</strong> {{ itemToDelete.typeName }}
        </div>
        <div *ngIf="deleteType === 'category'">
          <strong>Category Name:</strong> {{ itemToDelete.name }}
        </div>
        <div *ngIf="deleteType === 'type'">
          <strong>Type Name:</strong> {{ itemToDelete.type }}
        </div>
      </div>
      
      <p *ngIf="!deleteErrorMessage">This action cannot be undone.</p>
    </div>
    
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="closeDeleteModal()" [disabled]="modalLoader">Cancel</button>
      <button 
        type="button" 
        class="btn btn-primary" 
        (click)="confirmDelete()"
        [disabled]="modalLoader || deleteErrorMessage"
        *ngIf="!deleteErrorMessage">
        <span *ngIf="modalLoader" class="spinner"></span>
        Delete {{ deleteType | titlecase }}
      </button>
    </div>
    
    <div class="modal-loading-overlay" *ngIf="modalLoader" [class.show]="modalLoader">
      <div class="loading-spinner">
        <i class="fas fa-spinner fa-spin"></i>
      </div>
    </div>
  </div>
</div>

<!-- Order Modal -->
<div class="modal-overlay" *ngIf="showOrderModal" (click)="closeOrderModal()">
  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h4>{{ orderModalType === 'add' ? 'Add New Order' : 'Edit Order' }}</h4>
      <button class="close-btn" (click)="closeOrderModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>
    
    <div class="modal-body">
      <form [formGroup]="orderForm" (ngSubmit)="saveOrder()">
        <div class="form-row">
          <div class="form-group">
            <label for="orderName">Order Name *</label>
            <input 
              type="text" 
              id="orderName"
              formControlName="orderName" 
              class="form-control"
              placeholder="Enter order name"
              (click)="preventModalClose($event)"
              (focus)="preventModalClose($event)">
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="orderCategory">Category *</label>
            <select formControlName="orderCategory" class="form-control" (click)="preventModalClose($event)" (focus)="preventModalClose($event)">
              <option value="">Select Category</option>
              <option *ngFor="let category of orderCategories" [value]="category.id">
                {{ category.name }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="orderType">Type *</label>
            <select formControlName="orderType" class="form-control" (click)="preventModalClose($event)" (focus)="preventModalClose($event)">
              <option value="">Select Type</option>
              <option *ngFor="let type of orderTypes" [value]="type.id">
                {{ type.type }}
              </option>
            </select>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group width-50">
            <label for="frequencyVal">Frequency</label>

            
  

            <p-multiSelect 
              [options]="frequencyList" 
              formControlName="frequencyVal"
              optionLabel="type" 
              optionValue="id"
              placeholder="Select frequency options"
              [filter]="true"
              [showToggleAll]="false"
              appendTo="body"
              [showHeader]="false"
              styleClass="frequency-select"
              >
            </p-multiSelect>
          </div>
          <!-- <div class="form-group width-50">
            <label for="orderDay">Order Day</label>
            <input 
              type="number" 
              id="orderDay"
              formControlName="orderDay" 
              class="form-control"
              min="0"
              (click)="preventModalClose($event)"
              (focus)="preventModalClose($event)">
          </div> -->
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="prerequisiteOrder">Prerequisite Orders</label>
            <p-multiSelect 
              [options]="prerequisiteOrders" 
              formControlName="prerequisiteOrder"
              optionLabel="orderName" 
              optionValue="id"
              placeholder="Select prerequisite orders"
              [filter]="true"
              filterBy="orderName"
              [showToggleAll]="false"
              [showHeader]="true"
              [showClear]="true"
              styleClass="w-100">
            </p-multiSelect>
          </div>
          <div class="form-group">
            <label for="orderReturnTime">Return Time</label>
            <div class="return-time-container" *ngIf="showTimeSpinners">
              <div class="time-spinners">
                <div class="spinner-label">Day(s) : Hour(s) : Minute(s)</div>
                <div class="spinner-container">
                  <input type="number" 
                         [value]="simulationTime.days"
                         (input)="onDayChange($any($event.target).value)"
                         min="0"
                         max="999"
                         class="spinner-input"
                         (click)="preventModalClose($event)"
                         (focus)="preventModalClose($event)">
                  <input type="number" 
                         [value]="simulationTime.hours"
                         (input)="onHourChange($any($event.target).value)"
                         min="0"
                         max="23"
                         class="spinner-input"
                         (click)="preventModalClose($event)"
                         (focus)="preventModalClose($event)">
                  <input type="number" 
                         [value]="simulationTime.minutes"
                         (input)="onMinuteChange($any($event.target).value)"
                         min="0"
                         max="59"
                         class="spinner-input"
                         (click)="preventModalClose($event)"
                         (focus)="preventModalClose($event)">
                </div>
               
              </div>
            </div>
            <!-- Hidden input to maintain form structure -->
            <input 
              type="hidden" 
              id="orderReturnTime"
              formControlName="orderReturnTime">
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="routineOrderReturnTime">Routine Return Time (Optional)</label>
            <div class="return-time-container" *ngIf="showTimeSpinners">
              <div class="time-spinners">
                <div class="spinner-label">Day(s) : Hour(s) : Minute(s)</div>
                <div class="spinner-container">
                  <input type="number" 
                         [value]="routineSimulationTime.days"
                         (input)="onRoutineDayChange($any($event.target).value)"
                         min="0"
                         max="999"
                         class="spinner-input"
                         (click)="preventModalClose($event)"
                         (focus)="preventModalClose($event)">
                  <input type="number" 
                         [value]="routineSimulationTime.hours"
                         (input)="onRoutineHourChange($any($event.target).value)"
                         min="0"
                         max="23"
                         class="spinner-input"
                         (click)="preventModalClose($event)"
                         (focus)="preventModalClose($event)">
                  <input type="number" 
                         [value]="routineSimulationTime.minutes"
                         (input)="onRoutineMinuteChange($any($event.target).value)"
                         min="0"
                         max="59"
                         class="spinner-input"
                         (click)="preventModalClose($event)"
                         (focus)="preventModalClose($event)">
                </div>
               
              </div>
            </div>
            <!-- Hidden input to maintain form structure -->
            <input 
              type="hidden" 
              id="routineOrderReturnTime"
              formControlName="routineOrderReturnTime">
          </div>
        </div>

        <div class="form-row">
          <div class="form-group width-50">
            <label for="routeUrgencyType">Select Urgency or Route</label>
            <select 
              id="routeUrgencyType"
              formControlName="routeUrgencyType" 
              class="form-control"
              (change)="onRouteUrgencyTypeChange(+$event.target.value)"
              (click)="preventModalClose($event)"
              (focus)="preventModalClose($event)">
              <option *ngFor="let option of routeUrgCodes" [value]="option.id">
                {{ option.value }}
              </option>
            </select>
          </div>
          <div class="form-group width-50" [ngClass]="(showSecondaryDropdown)?'':'disable'">
            <label for="routeUrgencyVal">{{ (secondaryDropdownLabel)?secondaryDropdownLabel:'Select' }}</label>
            <p-multiSelect 
              [options]="secondaryDropdownOptions" 
              formControlName="routeUrgencyVal"
              [optionLabel]="selectedRouteUrgType === 1 ? 'displayLabel' : 'type'" 
              optionValue="id"
              [placeholder]="'Select ' + secondaryDropdownLabel"
              [filter]="true"
              filterBy="type,displayLabel"
              [showToggleAll]="false"
              [showHeader]="false"
              [showClear]="true"
              styleClass="w-100">
            </p-multiSelect>
          </div>
        </div>

        <!-- Secondary Dropdown (conditional) -->
        

        <div class="form-group response-input">
          <label for="response">Response</label>
          <div id="responseEditor" class="ck-editor-container" 
               (click)="preventModalClose($event)"
               (focus)="preventModalClose($event)"></div>
        </div>
      </form>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeOrderModal()">Cancel</button>
        <button 
          type="button" 
          class="btn btn-primary" 
          (click)="saveOrder()"
          [disabled]="orderForm.invalid || modalLoader">
          <span *ngIf="modalLoader" class="spinner"></span>
          {{ orderModalType === 'add' ? 'Add Order' : 'Update Order' }}
        </button>
      </div>
    </div>
    
    
    
    <div class="modal-loading-overlay" *ngIf="modalLoader" [class.show]="modalLoader">
      <div class="loading-spinner">
        <i class="fas fa-spinner fa-spin"></i>
      </div>
    </div>
  </div>
</div>

<!-- Category Modal -->
<div class="modal-overlay" *ngIf="showCategoryModal" (click)="closeCategoryModal()">
  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h4>{{ categoryModalType === 'add' ? 'Add New Category' : 'Edit Category' }}</h4>
      <button class="close-btn" (click)="closeCategoryModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>
    
    <div class="modal-body">
      <form [formGroup]="categoryForm" (ngSubmit)="saveCategory()">
        <div class="form-group">
          <label for="categoryName">Category Name *</label>
          <input 
            type="text" 
            id="categoryName"
            formControlName="name" 
            class="form-control"
            placeholder="Enter category name"
            (click)="preventModalClose($event)"
            (focus)="preventModalClose($event)">
        </div>
      </form>
    </div>
    
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="closeCategoryModal()">Cancel</button>
      <button 
        type="button" 
        class="btn btn-primary" 
        (click)="saveCategory()"
        [disabled]="categoryForm.invalid || modalLoader">
        <span *ngIf="modalLoader" class="spinner"></span>
        {{ categoryModalType === 'add' ? 'Add Category' : 'Update Category' }}
      </button>
    </div>
    
    <div class="modal-loading-overlay" *ngIf="modalLoader" [class.show]="modalLoader">
      <div class="loading-spinner">
        <i class="fas fa-spinner fa-spin"></i>
      </div>
    </div>
  </div>
</div>

<!-- Type Modal -->
<div class="modal-overlay" *ngIf="showTypeModal" (click)="closeTypeModal()">
  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h4>{{ typeModalType === 'add' ? 'Add New Type' : 'Edit Type' }}</h4>
      <button class="close-btn" (click)="closeTypeModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>
    
    <div class="modal-body">
      <form [formGroup]="typeForm" (ngSubmit)="saveType()">
        <div class="form-group">
          <label for="typeName">Type Name *</label>
          <input 
            type="text" 
            id="typeName"
            formControlName="type" 
            class="form-control"
            placeholder="Enter type name"
            (click)="preventModalClose($event)"
            (focus)="preventModalClose($event)">
        </div>
      </form>
    </div>
    
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="closeTypeModal()">Cancel</button>
      <button 
        type="button" 
        class="btn btn-primary" 
        (click)="saveType()"
        [disabled]="typeForm.invalid || modalLoader">
        <span *ngIf="modalLoader" class="spinner"></span>
        {{ typeModalType === 'add' ? 'Add Type' : 'Update Type' }}
      </button>
    </div>
    
    <div class="modal-loading-overlay" *ngIf="modalLoader" [class.show]="modalLoader">
      <div class="loading-spinner">
        <i class="fas fa-spinner fa-spin"></i>
      </div>
    </div>
  </div>
</div>

<!-- Explanation Modal -->
<div class="modal-overlay" *ngIf="showExplanationModal" (click)="closeExplanationModal()" role="dialog" aria-modal="true" aria-labelledby="explanationModalTitle">
  <div class="modal-dialog explanation-modal-dialog" (click)="preventModalClose($event)" role="document">
    <div class="modal-header">
      <h4 id="explanationModalTitle">{{ explanationModalType === 'add' ? 'Add Case Explanation' : 'Edit Case Explanation' }}</h4>
      <span class="case-info" *ngIf="currentExplanationCase">Case ID: {{ currentExplanationCase.id }}</span>
      <button class="close-btn" (click)="closeExplanationModal()" aria-label="Close modal">
        <i class="fas fa-times"></i>
      </button>
    </div>
    
    <div class="modal-body explanation-modal-body">
      <form [formGroup]="explanationForm" (ngSubmit)="saveExplanation()">
        
        <!-- Approach Section -->
        <div class="explanation-section">
          <label class="section-label" for="approachEditor">
            <i class="fas fa-route"></i>
            Approach to the Case
          </label>
          <div class="editor-container">
            <div id="approachEditor" class="ck-editor-container" role="textbox" aria-label="Approach to the Case"></div>
          </div>
        </div>

        <!-- Scoring Section -->
        <div class="explanation-section">
          <label class="section-label" for="scoringEditor">
            <i class="fas fa-chart-line"></i>
            Scoring
          </label>
          <div class="editor-container">
            <div id="scoringEditor" class="ck-editor-container" role="textbox" aria-label="Scoring"></div>
          </div>
        </div>

        <!-- Clock Management Section -->
        <div class="explanation-section">
          <label class="section-label" for="clockManagementEditor">
            <i class="fas fa-clock"></i>
            Clock Management
          </label>
          <div class="editor-container">
            <div id="clockManagementEditor" class="ck-editor-container" role="textbox" aria-label="Clock Management"></div>
          </div>
        </div>

      </form>
    </div>
    
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="closeExplanationModal()">Cancel</button>
      <button 
        type="button" 
        class="btn btn-primary" 
        (click)="saveExplanation()"
        [disabled]="modalLoader">
        <span *ngIf="modalLoader" class="spinner" aria-hidden="true"></span>
        {{ explanationModalType === 'add' ? 'Add Explanation' : 'Update Explanation' }}
      </button>
    </div>
    
    <div class="modal-loading-overlay" *ngIf="modalLoader" [class.show]="modalLoader" aria-hidden="true">
      <div class="loading-spinner">
        <i class="fas fa-spinner fa-spin"></i>
      </div>
    </div>
  </div>
</div> 



<div *ngIf="loading" class="text-center py-4">
  <app-overlay-loader *ngIf="loading"></app-overlay-loader>
</div>